// @flow
import React from 'react';
import ModalDialog from '../ModalDialog/ModalDialog';
import ProductRowForm from '../ProductRowForm/ProductRowForm';
import ServerError from '../ServerError/ServerError';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import _ from 'lodash/fp';

export type Props = {
  products: any[],
  variants: any[],
  existingRows: any[],
  rooms: any[],
  activeRow: Object,
  formValues: any,
  validate: Function,
  isLoading: boolean,
  error: ?any,
  onSave: Function,
  onSelectProduct: Function,
  onClose: Function,
  onOpen: ?Function,
  combineProduct: boolean,
};

const ProductRowDialog = ({
  activeRow,
  products,
  variants,
  rooms,
  formValues,
  validate,
  isLoading,
  error,
  existingRows,
  onSave,
  onSelectProduct,
  onOpen,
  onClose,
  combineProduct,
}: Props) => (
  <div>
    <ModalDialog
      onOpen={onOpen ? onOpen : _.noop}
      onClose={onClose}
      className="AdditionalRowDialog"
      show={true}>
      <LoadingIndicator isLoading={isLoading} />
      <ServerError error={error} />
      <ProductRowForm
        initialValues={activeRow}
        existingRows={existingRows}
        activeRow={activeRow}
        products={products}
        variants={variants}
        rooms={rooms}
        formValues={formValues}
        onSelectProduct={onSelectProduct}
        validate={validate}
        combineProduct={combineProduct}/>
      <button
        type="button"
        className="expanded button"
        onClick={onSave}>
        {activeRow.id ? 'Uppdatera' : 'Lägg till'}
      </button>
      <button
        type="button"
        className="expanded button"
        onClick={onClose}>
        Avbryt
      </button>
    </ModalDialog>
  </div>
);

export default ProductRowDialog;



// WEBPACK FOOTER //
// ./src/components/ProductRowDialog/ProductRowDialog.js